import { AxiosError } from 'axios'
import { ApiError, isApiError, normalizeAxiosError } from '../../../lib/apiError'

export function toApiError(err: unknown): ApiError {
  if (isApiError(err)) return err
  if (err instanceof AxiosError) return normalizeAxiosError(err)
  return new ApiError({ kind: 'unknown', status: 0, message: 'Something went wrong. Please try again.' })
}
